import React from "react";
import PropTypes from "prop-types";
import _ from 'lodash';

import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import {withStyles} from "@material-ui/core";


const PeopleList = ({classes, onItemClick, data, endAdornment}) => {
  if (_.isEmpty(data)) return <Typography
    variant='h6'
  >
    Nenhum item encontrado...
  </Typography>;
  return <List className={classes.list}>
    {data.map((el, idx) =>
    <div key={idx} onClick={onItemClick(el._id)}>
      <Divider component="li" variant="fullWidth" light/>
      <ListItem button>
        <ListItemText
          primary={el._id}
          secondary={`${el.slotNumber} caçambas${el.finalSlot ? ', Final' : ''}${el.paused ? ', Pausado' : ''}`}
        />
        <ListItemIcon>
          {endAdornment}
        </ListItemIcon>
      </ListItem>
    </div>
    )}
  </List>;
};

PeopleList.propTypes = {
  classes: PropTypes.object.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
    })).isRequired,
  onItemClick: PropTypes.func.isRequired,
  endAdornment: PropTypes.object,
};

PeopleList.defaultProps = {
  endAdornment: <></>
};

const styles = () => ({
  list: {
    height: '100%',
    overflow: 'auto',
    width: '100%',
  },
});

export default withStyles(styles)(PeopleList);
